module.exports = __webpack_public_path__ + "img/body-2.0c33465e.png";